let language = {
    STORE_PRODUCT_LIST_EMPTY_DES1:"Click",
    STORE_PRODUCT_LIST_EMPTY_DES2:"here",
    STORE_PRODUCT_LIST_EMPTY_DES3:"to see our Catalog and select the products you would like to offer your customers. You can customize products by adding your design or allowing your customer to customize it in your store with their design. "

};

export { language }